import viLocale from 'element-ui/lib/locale/lang/vi'
import home from './vi/home'

const vi = {
    language: 'Tiếng Việt',
    message: {
        'home': {
            ...home,
            enterEmail: 'Vui lòng nhập email',
            save: 'Lưu',
            saveSuccess: 'Lưu thành công',
            pointHistory: 'Lịch sử điểm',
            type: 'Loại',
            remark: 'Ghi chú',
            pendingComment: 'Chờ đánh giá',
            commented: 'Đã đánh giá',
            selectDate: 'Chọn ngày',
            loginSuccess: 'Đăng nhập thành công',
            loginFail: 'Đăng nhập thất bại',
            close: 'Đóng',
            required: 'Bắt buộc',
            nickname: 'Biệt danh',
            enterNickname: 'Vui lòng nhập biệt danh',
            gender: 'Giới tính',
            male: 'Nam',
            female: 'Nữ',
            secret: 'Bí mật',
            birthday: 'Ngày sinh',
            checkoutLoadFailed: 'Tải thông tin thanh toán thất bại. Vui lòng thử lại sau.',
            checkoutErrorTitle: 'Thông báo',
            goAddAddress: 'Thêm địa chỉ nhận hàng',
            shop_order_selectOrAddAddress: 'Vui lòng thêm địa chỉ nhận hàng và đặt làm mặc định trước khi thanh toán.',
            shop_order_cartEmpty: 'Giỏ hàng trống, không thể thanh toán.',
            shop_order_cartHasNotActive: 'Có sản phẩm chưa đăng bán hoặc không hợp lệ, không thể thanh toán.',
            shop_order_cartHasNotMarketable: 'Có sản phẩm đã ngừng bán, không thể thanh toán.',
            shop_order_cartHasLowStock: 'Không đủ hàng tồn kho, không thể thanh toán.',
            shop_order_cartHasExpiredGoods: 'Một số sản phẩm của cửa hàng đã hết hạn, không thể thanh toán.',
            shop_order_typeIsNull: 'Không nhận dạng được loại đơn hàng, vui lòng kiểm tra loại sản phẩm.',
            shop_order_goodsNotFound: 'Thông tin sản phẩm không tồn tại hoặc đã bị xóa.',
            shop_order_giftNotForSale: 'Sản phẩm quà tặng không thể mua trực tiếp.',
            common_message_badRequest: 'Yêu cầu không hợp lệ, vui lòng kiểm tra sản phẩm và tham số.',
        },
    },
    '手机号码最小长度为8位': 'Độ dài tối thiểu của số điện thoại di động là 8 chữ số',
    '邮箱账号名称最小长度为6位': 'Độ dài tối thiểu của tên tài khoản email là 6 ký tự',
    '邮箱只能包含英文，数字等字符': 'Email chỉ có thể chứa tiếng Anh, số và các ký tự khác',
    '请选择正确的收货地址': 'Vui lòng chọn địa chỉ giao hàng chính xác',
    Dict_language_status_0: 'Đã tắt',
    Dict_language_status_1: 'Đã bật',
    Dict_member_label_type_1: 'Nhãn điều kiện',
    Dict_member_label_type_2: 'Nhãn thủ công',
    Dict_member_level_type_0: 'Cấp tiêu dùng (LV)',
    Dict_member_level_type_1: 'Thành viên trả phí (VIP)',
    Dict_member_growth_action_type_1: 'Đặt hàng',
    Dict_member_growth_action_type_2: 'Đăng nhập hằng ngày',
    Dict_member_growth_action_type_3: 'Đăng đánh giá',
    Dict_member_growth_action_type_4: 'Hoàn thiện hồ sơ',
    Dict_paid_member_payment_type_0: 'Thanh toán bằng số dư',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Hiệu lực',
    Dict_paid_member_record_status_1: 'Đã hết hạn',
    Dict_paid_member_record_status_2: 'Đã hoàn tiền',
    Dict_point_lottery_prize_type_0: 'Điểm',
    Dict_point_lottery_prize_type_1: 'Phiếu giảm giá',
    Dict_point_lottery_prize_type_2: 'Giải thưởng hiện vật',
    Dict_point_lottery_prize_type_3: 'Cảm ơn đã tham gia',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'Email',
    Dict_notification_channel_type_2: 'Tin nhắn nội bộ',
    Dict_notification_channel_type_3: 'Thông báo đẩy',
    Dict_announcement_status_0: 'Bản nháp',
    Dict_announcement_status_1: 'Đã đăng',
    Dict_announcement_status_2: 'Đã gỡ',
    Dict_live_permission_status_0: 'Chưa đăng ký',
    Dict_live_permission_status_1: 'Đang duyệt',
    Dict_live_permission_status_2: 'Đã kích hoạt',
    Dict_live_permission_status_3: 'Đã từ chối',
    Dict_live_room_status_0: 'Chưa bắt đầu',
    Dict_live_room_status_1: 'Đang phát',
    Dict_live_room_status_2: 'Đã kết thúc',
    Dict_live_room_status_3: 'Gián đoạn bất thường',
    Dict_live_room_type_0: 'Phát trực tiếp nền tảng',
    Dict_live_room_type_1: 'Phát trực tiếp người bán',
    Dict_store_type_0: 'Cửa hàng cá nhân',
    Dict_store_type_1: 'Cửa hàng doanh nghiệp',
    Dict_store_sign_status_0: 'Chờ ký kết',
    Dict_store_sign_status_1: 'Đã ký kết',
    Dict_store_sign_status_2: 'Đã chấm dứt',
    Dict_store_business_change_status_0: 'Chờ duyệt',
    Dict_store_business_change_status_1: 'Đã duyệt',
    Dict_store_business_change_status_2: 'Bị từ chối',
    Dict_decoration_page_type_0: 'Trang chủ',
    Dict_decoration_page_type_1: 'Trang danh mục',
    Dict_decoration_page_type_2: 'Trang sự kiện',
    Dict_decoration_page_type_3: 'Trang tùy chỉnh',
    Dict_decoration_status_0: 'Bản nháp',
    Dict_decoration_status_1: 'Đã đăng',
    Dict_decoration_popup_trigger_page_0: 'Trang chủ nền tảng',
    Dict_decoration_popup_trigger_page_1: 'Trung tâm thành viên',
    Dict_decoration_popup_trigger_page_2: 'Thanh toán thành công',
    Dict_decoration_popup_target_user_0: 'Tất cả người dùng',
    Dict_decoration_popup_target_user_1: 'Thành viên miễn phí',
    Dict_decoration_popup_target_user_2: 'Thành viên trả phí',
    Dict_decoration_popup_frequency_0: 'Vĩnh viễn một lần',
    Dict_decoration_popup_frequency_1: 'Mỗi lần truy cập',
    Dict_decoration_popup_frequency_2: 'Tần suất tùy chỉnh',
    Dict_track_event_type_page_view: 'Lượt xem trang',
    Dict_track_event_type_click: 'Nhấp',
    Dict_track_event_type_add_to_cart: 'Thêm vào giỏ',
    Dict_track_event_type_search: 'Tìm kiếm',
    Dict_track_event_type_purchase: 'Mua',
    Dict_track_event_type_live_watch: 'Xem trực tiếp',
    Dict_reconcile_period_type_0: 'Hằng ngày',
    Dict_reconcile_period_type_1: 'Hằng tuần',
    Dict_reconcile_period_type_2: 'Hằng tháng',
    Dict_store_settlement_status_0: 'Chờ quyết toán',
    Dict_store_settlement_status_1: 'Đã quyết toán',
    Dict_distributor_status_0: 'Chờ duyệt',
    Dict_distributor_status_1: 'Đã duyệt',
    Dict_distributor_status_2: 'Bị từ chối',
    Dict_distribution_commission_type_0: 'Hoa hồng trực tiếp',
    Dict_distribution_commission_type_1: 'Hoa hồng gián tiếp',
    Dict_configuration_status_0: 'Đã tắt',
    Dict_configuration_status_1: 'Đã bật',
    ...viLocale
}
export default vi
